import { createApp } from 'vue';
import SmartLid from 'Vue/containers/SmartLid.vue';

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.addVueApp = function () {
    createApp(SmartLid).mount('#slc');
    
};

module.init = function () {
	module.addVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
    module.init();
});
